import { type PropsWithChildren } from "react";

export interface LayoutProps {
  fluid?: boolean;
  containerOnly?: boolean;
  cols?: string;
  row?: string;
}

export default function Layout(props: PropsWithChildren<LayoutProps>) {
  const { fluid, containerOnly, cols = "col", row = "row", children } = props;

  return (
    <div className={fluid ? "container-fluid" : "container"}>
      {containerOnly ? (
        children
      ) : (
        <div className={row}>
          <div className={cols}>{children}</div>
        </div>
      )}
    </div>
  );
}
